import { render, staticRenderFns } from "./KsWarningTooltip.vue?vue&type=template&id=6fd20b80&scoped=true"
import script from "./KsWarningTooltip.vue?vue&type=script&lang=js"
export * from "./KsWarningTooltip.vue?vue&type=script&lang=js"
import style0 from "./KsWarningTooltip.vue?vue&type=style&index=0&id=6fd20b80&prod&lang=scss&scoped=true"
import style1 from "./KsWarningTooltip.vue?vue&type=style&index=1&id=6fd20b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd20b80",
  null
  
)

export default component.exports